import React from 'react';
import { CalendarCheck, FileText, ClipboardList, Stethoscope, Microscope, HeartHandshake, ShieldCheck } from 'lucide-react';
export function PatientInformation() {
  return <div className="min-h-screen bg-brand-light pb-20" data-id="element-751" data-mp="39n43ozx448a2">
      {/* Hero Band */}
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-752" data-mp="3elxfmnwr3r84">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-753" data-mp="3ek4876ebd2z2">
          <span className="text-brand-gold font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-754" data-mp="30kl2ek8z63px">
            Patient Guide
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-755" data-mp="2qo893nhcdrvp">
            Patient Information
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-756" data-mp="2vo4f1s9lntdw">
            Everything you need to know before your visit to Maisha Medical
            Center to ensure a smooth and comfortable experience.
          </p>
        </div>
      </div>

      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-757" data-mp="1sr7ogksf8ipm">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-758" data-mp="1sped4s6v5aba">
          {/* Left Column: Info Cards */}
          <div className="lg:col-span-2 space-y-8" data-id="element-759" data-mp="1nqjvhtkmtrsr">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-760" data-mp="22fz9sa2z84rk">
              <div className="flex items-center gap-4 mb-6" data-id="element-761" data-mp="1xj8v9r6tlh89">
                <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-navy" data-id="element-762" data-mp="19slml3p2ynkn">
                  <CalendarCheck className="w-6 h-6" data-id="element-763" data-mp="14u1vkovmqllf" />
                </div>
                <h2 className="text-2xl font-heading font-bold text-brand-navy" data-id="element-764" data-mp="1itbf9yj1nxu5">
                  Appointments
                </h2>
              </div>
              <p className="text-slate-600 leading-relaxed" data-id="element-765" data-mp="1eqwwtfjaf03e">
                Patients are encouraged to schedule appointments in advance to
                minimize wait times and ensure our specialists are available.
                However, walk-ins may be accommodated depending on availability
                and the urgency of the medical condition.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-766" data-mp="1rtr1ygloykaq">
              <div className="flex items-center gap-4 mb-6" data-id="element-767" data-mp="1wv6o6bzluwup">
                <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-navy" data-id="element-768" data-mp="20vqil7ssnmd5">
                  <ShieldCheck className="w-6 h-6" data-id="element-769" data-mp="145zoh9of017v" />
                </div>
                <h2 className="text-2xl font-heading font-bold text-brand-navy" data-id="element-770" data-mp="194kg4kplpckp">
                  Medical Records
                </h2>
              </div>
              <p className="text-slate-600 leading-relaxed" data-id="element-771" data-mp="1d5cshmtrrxl7">
                All patient records are handled with the strictest
                confidentiality in compliance with healthcare regulations. Your
                medical history is securely stored and only accessible to
                authorized medical personnel involved in your care.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-772" data-mp="hvzq0g5pbhje">
              <div className="flex items-center gap-4 mb-6" data-id="element-773" data-mp="cxpto288qaw7">
                <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-navy" data-id="element-774" data-mp="cw4ufzaze3s0">
                  <ClipboardList className="w-6 h-6" data-id="element-775" data-mp="3xsxlfjiu9r4" />
                </div>
                <h2 className="text-2xl font-heading font-bold text-brand-navy" data-id="element-776" data-mp="3zm9pacwlm6i">
                  Preparing For Your Visit
                </h2>
              </div>
              <p className="text-slate-600 leading-relaxed mb-6" data-id="element-777" data-mp="3qbb23b37v8hg">
                To help us provide you with the best possible care, please
                ensure you bring the following items to your appointment:
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-778" data-mp="3hacxaqkyewxt">
                {['National Identification or Passport', 'Referral letter (if applicable)', 'Previous medical history/records', 'List of current medications', 'Medical aid/Insurance information'].map((item, idx) => <li key={idx} className="flex items-start gap-3 bg-brand-lighter p-4 rounded-xl" data-id="element-779" data-mp="1gbre4l33bevt" data-mpi={idx}>
                    <div className="w-2 h-2 rounded-full bg-brand-gold mt-2 shrink-0" data-id="element-780" data-mp="16iu0otcygg42" />
                    <span className="text-slate-700 font-medium text-sm" data-id="element-781" data-mp="sjau44zslctv">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Right Column: What to Expect Timeline */}
          <div className="lg:col-span-1" data-id="element-782" data-mp="nkr9q90uk93m">
            <div className="bg-brand-navy p-8 rounded-2xl shadow-soft-lg text-white sticky top-28" data-id="element-783" data-mp="nlstd1vxi3wy">
              <h2 className="text-2xl font-heading font-bold text-white mb-8" data-id="element-784" data-mp="2d10f3vg3t1xe">
                What To Expect
              </h2>

              <div className="space-y-6" data-id="element-785" data-mp="6byfx5ozc8hl">
                <div className="flex items-center gap-5" data-id="element-786" data-mp="6d02o7fcyjf5">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-red text-white shrink-0 shadow-md" data-id="element-787" data-mp="1cvnckq6ruqi">
                    <FileText className="w-5 h-5" data-id="element-788" data-mp="g2tdh67oeuic" />
                  </div>
                  <div data-id="element-789" data-mp="bbb9sae9qfto">
                    <h3 className="font-heading font-bold text-lg mb-1" data-id="element-790" data-mp="ba08qic7jm69">
                      1. Reception
                    </h3>
                    <p className="text-slate-300 text-sm" data-id="element-791" data-mp="p0lm5riw73wr">
                      Registration, verifying details, and initial vitals check.
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-5" data-id="element-792" data-mp="yyjeor7sbmv6">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-red text-white shrink-0 shadow-md" data-id="element-793" data-mp="u2kkuo3otcnd">
                    <Stethoscope className="w-5 h-5" data-id="element-794" data-mp="30u3d4h4w6kvp" />
                  </div>
                  <div data-id="element-795" data-mp="2vugzi6l5j2md">
                    <h3 className="font-heading font-bold text-lg mb-1" data-id="element-796" data-mp="2vv8txe30iub2">
                      2. Consultation
                    </h3>
                    <p className="text-slate-300 text-sm" data-id="element-797" data-mp="3pi3mu466vs8h">
                      Detailed discussion of symptoms with our medical
                      professionals.
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-5" data-id="element-798" data-mp="3czvicmvu0qg">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-red text-white shrink-0 shadow-md" data-id="element-799" data-mp="8b1hp6flug65">
                    <Microscope className="w-5 h-5" data-id="element-800" data-mp="cajzhtc4qb4r" />
                  </div>
                  <div data-id="element-801" data-mp="h3uxr62vljl2">
                    <h3 className="font-heading font-bold text-lg mb-1" data-id="element-802" data-mp="h3d48h7lljgu">
                      3. Diagnosis
                    </h3>
                    <p className="text-slate-300 text-sm" data-id="element-803" data-mp="r0zmndo3vt5k">
                      Laboratory tests or imaging if required for accurate
                      assessment.
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-5" data-id="element-804" data-mp="2giemehyuuj7m">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-red text-white shrink-0 shadow-md" data-id="element-805" data-mp="2gfs9e2t73bi0">
                    <ClipboardList className="w-5 h-5" data-id="element-806" data-mp="26j5oje0vckfz" />
                  </div>
                  <div data-id="element-807" data-mp="21l452rzj6j3z">
                    <h3 className="font-heading font-bold text-lg mb-1" data-id="element-808" data-mp="21lxfq41m1sre">
                      4. Treatment Plan
                    </h3>
                    <p className="text-slate-300 text-sm" data-id="element-809" data-mp="2zapb97wocgmq">
                      Prescriptions, procedures, or specialist referrals
                      provided.
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-5" data-id="element-810" data-mp="2kjzvrtc6kfd2">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-red text-white shrink-0 shadow-md" data-id="element-811" data-mp="2kjgfsi63c11o">
                    <HeartHandshake className="w-5 h-5" data-id="element-812" data-mp="3d8np8c732b1p" />
                  </div>
                  <div data-id="element-813" data-mp="3d6kmqsoqupg3">
                    <h3 className="font-heading font-bold text-lg mb-1" data-id="element-814" data-mp="2lkavfkuj38ho">
                      5. Follow-Up
                    </h3>
                    <p className="text-slate-300 text-sm" data-id="element-815" data-mp="2qccebpm7bxgo">
                      Scheduling your next visit to monitor recovery progress.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}